import { transformSearch } from "@/api/helper.ts";
import { queryClient } from "@/query-client";
import { queryOptions, useMutation } from "@tanstack/react-query";
import { z } from "zod";
import roleListService from "../services/role-list-service";

export const roleListSearchSchema = z.object({
	search: z.string().optional(),
	page: z.number().nullable().optional(),
	per_page: z.number().optional(),
});

export const rolesListQueryOptions = (search?: z.infer<typeof roleListSearchSchema>) => {
	return queryOptions({
		queryKey: ["roles", search],
		queryFn: () => roleListService.list(transformSearch(search, ["search"])),
	});
};

export const roleListQueryOptions = (roleId: string) => {
	return queryOptions({
		queryKey: ["roles", roleId],
		queryFn: () => roleListService.findById(roleId),
	});
};

export const useRoleMutation = (roleId?: string) => {
	return useMutation({
		mutationKey: ["roles", roleId],
		mutationFn: roleListService.upsert,
		meta: {
			successMessage: "Role updated successfully",
		},
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ["roles"] }),
	});
};
